import { render, staticRenderFns } from "./app-bar.vue?vue&type=template&id=6180148a&scoped=true&lang=pug&"
import script from "./app-bar.vue?vue&type=script&lang=ts&"
export * from "./app-bar.vue?vue&type=script&lang=ts&"
import style0 from "./app-bar.vue?vue&type=style&index=0&id=6180148a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6180148a",
  null
  
)

export default component.exports